export default {
      id: "icon-add-usage",
      viewBox: "-3 -3 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-add",
      toString: function () {
        return this.url;
      }
    }